import { EditOutlined, EyeOutlined, FieldTimeOutlined, PrinterOutlined, DownloadOutlined } from "@ant-design/icons";
import { Button, Table, Space, Drawer, List, Avatar, Row, Col, Switch, Card, Descriptions, Tag, Grid, Collapse, Divider } from 'antd';


import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import ProgrammeService from "../../api/programme.service";
import commonUtility from "../../utility/Utils";
import moment from 'moment';
import * as XLSX from "xlsx";

const { Panel } = Collapse;

const TimeScheduleReport = (props) => {
    // const [paymentPaidList, setPaymentPaidList] = useState([]);
    // const [bookingTimeSlotList, setBookingTimeSlotList] = useState([]);
    // const [bookingTimeSlotListDetailView, setBookingTimeSlotListDetailView] = useState([]);
    // const [visible, setVisible] = useState(false);
    // const [filteredSearchList, setFilteredSearchList] = useState([]);

    // const [memberName, setMemberName] = useState("");
    // const [memberMobileNo, setMemberMobileNo] = useState("");
    // const [receiptNo, setReceiptNo] = useState("");
    const [bookingValidity, setBookingValidity] = useState("");

    const [timeScheduleWithMember, setTimeScheduleWithMember] = useState([]);
    const [page, setPage] = useState(1);

    let navigate = useNavigate();

    const collapseStyle = {
        width: '100%',
        maxWidth: '100%',
        marginBottom: 10,
        background: "#fff",
        border: "0",
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
    };


    // update by Rittik Start//
    // const preprocessData = (reportList) => {
    //     let data = [];

    //     reportList.forEach(item => {
    //         Object.entries(item.DayData).forEach(([dayName, members]) => {
    //             members.forEach(member => {
    //                 let existingMember = data.find(m => m.member_id === member.member_id);
    //                 if (existingMember) {
    //                     existingMember.days += `, ${dayName}`;
    //                 } else {
    //                     data.push({
    //                         ...member,
    //                         days: dayName,
    //                         time_slot: item?.timeSlot?.time_slot || "Unknown",
    //                         shift: item?.timeSlot?.shift || "Unknown"
    //                     });
    //                 }
    //             });
    //         });
    //     });

    //     return data;
    // };

    // update by Rittik End//

    const pageSize = 10;

    const pagination = {
        current: page,
        pageSize: pageSize,
    };

    const columns = [
        {
            title: '#',
            dataIndex: 'index',
            render: (text, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
            width: '5%',
        },
        {
            title: 'Name',
            dataIndex: 'member',
            key: 'member',
        },
        {
            title: 'Mobile No',
            dataIndex: 'primary_mobile',
            key: 'primary_mobile',
        },
        {
            title: 'Father Name',
            dataIndex: 'father_name',
            key: 'father_name',
        },
        // {
        //     title: 'Gender',
        //     dataIndex: 'gender',
        //     key: 'gender',
        // },
        {
            title: 'Period',
            dataIndex: 'enrollment_start_date',
            key: 'enrollment_start_date',
            render: (text, record) => {
                const startDate = moment(record.enrollment_start_date).format('DD-MM-YYYY');
                const endDate = record.enrollment_end_date ? moment(record.enrollment_end_date).format('DD-MM-YYYY') : ''; // Format end date or keep it empty if not available
                return `${startDate} - ${endDate}`;
            },
        },

        {
            title: 'Booked Days',
            dataIndex: 'day_name',
            key: 'day_name',
        },
        {
            title: 'Shift',
            dataIndex: 'programme_group',
            key: 'programme_group',
        },
        {
            title: "Programme",
            dataIndex: 'programme_name',
            key: 'programme_name',
        }
    ];
    // update by Rittik Start//

    // useEffect(() => {
    //     const data = preprocessData(props.reportList);
    //     setTimeScheduleWithMember(data);
    // }, [props.reportList]);

    // update by Rittik End//

    // const ConvertedData = () => {
    //     const formattedData = data.response_data.map((item) => {
    //         const groupedData = item.DayData.reduce((acc, curr) => {
    //             if (!acc[curr.day_name]) {
    //                 acc[curr.day_name] = [];
    //             }
    //             acc[curr.day_name].push({ member_name: curr.member_name });
    //             return acc;
    //         }, {});

    //         return {
    //             timeSlot: item.timeSlot,
    //             DayData: groupedData,
    //         };
    //     });

    //     return formattedData;
    // }

    // useEffect(() => {

    //     let convert = ConvertedData();
    //     console.log('convert', convert);

    //     setTimeScheduleWithMember(convert);

    // }, []);


    useEffect(() => {
        console.log('reportListX', props.reportList);
    }, []);

    console.log('reportListX', props.reportList);

    const exportToExcel = () => {
        const exportData = props.reportList.map(item => ({
            'Name': item.member,
            'Primary Mobile': item.primary_mobile,
            'Father Name': item.father_name,
           'Period': `${new Date(item.enrollment_start_date).toLocaleDateString('en-GB')} to ${new Date(item.enrollment_end_date).toLocaleDateString('en-GB')}`,
            'Booked Days': item.day_name,
            'Shift': item.programme_group,
            'Programme': item.programme_name
        }));
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "schedule_report.xlsx");
    };

    return (
        <div style={{ marginTop: 5, background: '#FFF' }} key={commonUtility.randomID()}>
            {/* {
                props.reportList.length > 0 ? <>
                    <Divider orientation="left" style={{ marginTop: 0 }}>Report By Time Slot </Divider>

                    {props.reportList.map((item, index) => {
                        let count = 0;
                        let defaultkey = "panel" + index;

                        return (
                            <div key={commonUtility.randomID()}>
                              

                                <Table key={commonUtility.randomID()} columns={columns} dataSource={props.reportList} size="small" pagination={false} />

                            </div>
                        );
                    })}
                </> : <div key={commonUtility.randomID()}>
                    <h6>No Data Available</h6>
                </div>
            } */}

            <Col xs={24} xl={2}>
                <Button htmlType="button" shape="round" className="custom-button-green"
                    onClick={exportToExcel}
                >
                    <DownloadOutlined /> Excel
                </Button>
            </Col>

            <Table key={commonUtility.randomID()} columns={columns} dataSource={props.reportList} size="small"
                pagination={{
                    current: page,
                    pageSize,
                    // total: filteredSearchList.length,
                    onChange: (page) => setPage(page),
                }}

            />


        </div>

        //   Updated By Rittik Start //
        // <div style={{ marginTop: 5, background: '#FFF' }} key={commonUtility.randomID()}>
        //     {
        //         props.reportList.length > 0 ? <>
        //             <Divider orientation="left" style={{ marginTop: 0 }}>Report By Time Slot </Divider>

        //             {props.reportList.map((item, index) => {
        //                 let defaultkey = "panel" + index;

        //                 return (
        //                     <div key={commonUtility.randomID()}>
        //                         <Collapse collapsible="header" defaultActiveKey={[defaultkey]} style={{
        //                             width: '100%',
        //                             maxWidth: '100%',
        //                             marginBottom: 10,
        //                             background: "#fff",
        //                             border: "0",
        //                             boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
        //                         }}>
        //                             <Panel header={item?.timeSlot?.time_slot !== "" ? item?.timeSlot?.time_slot : ""} key={defaultkey} style={{ background: 'rgb(216, 255, 222)', fontWeight: '500', border: 0 }}>
        //                                 <Table key={commonUtility.randomID()} columns={columns} dataSource={timeScheduleWithMember} size="small" pagination={false} />
        //                             </Panel>
        //                         </Collapse>
        //                     </div>
        //                 );
        //             })}
        //         </> : <div key={commonUtility.randomID()}>
        //             <h6>No Data Available</h6>
        //         </div>
        //     }
        // </div>
        //   Updated By Rittik End //
    );


}


export default TimeScheduleReport;